import { useTranslation } from "react-i18next";
import { Avatar } from "@/shared/ui";
import type { ImportWorkerDraftListItem } from "../../../types";

interface Props {
  draft: ImportWorkerDraftListItem;
}

export default function DraftNameCell({ draft }: Props) {
  const { t } = useTranslation("EmployeesPage");
  const fullName = draft.full_name || "-";

  return (
    <div className="flex items-center gap-3">
      <Avatar name={fullName} size={36} />
      <div className="flex flex-col min-w-0">
        <span className="text-label-sm content-base-primary truncate max-w-[200px]" title={fullName}>
          {fullName}
        </span>
        <span className="text-body-regular-xs content-base-secondary">{t("table.iinPrefix", { iin: draft.iin || "—" })}</span>
      </div>
    </div>
  );
}
